import { useI18n } from '../i18n';
import { BANNER_IMG } from '../constants';
import { Reveal } from './Reveal';

/** Full-width cinematic banner: "Where the journey began". */
export const ExperienceBanner = () => {
  const { t } = useI18n();
  return (
    <section className="banner">
      <div className="banner-bg" style={{ backgroundImage: `url('${BANNER_IMG}')` }} />
      <Reveal className="inner">
        <span className="kicker" style={{ justifyContent: 'center' }}>
          {t.experience.kicker}
        </span>
        <h2>{t.experience.title}</h2>
      </Reveal>
    </section>
  );
};
